export default __webpack_public_path__ + "static/media/pic5.15a4335c.jpg";